<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J37EsI/tc-custom/9781504027526.jpg?1734099134361" alt="This image is the cover for the book Guardian"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guardian
      </h1>
      <p class="bookDescription body article font2">
        <b>The evil continues </b><b>in this sequel to the <i>New York Times</i>–bestselling <i>The Sentinel</i></b><br/><br/> Satanic forces return to an apartment building on Manhattan’s Upper West Side with the discovery of a grotesque, charred body and two other eerily linked murders. When the young woman who stumbles upon the body is raped, her husband begins a furious quest for revenge. Meanwhile in the building, a blind and paralyzed nun with sinister intentions stares vacantly out of an upstairs window and a cunning priest tries desperately to save more innocent lives from destruction. Full of hellish twists and turns, <i>The Guardian</i> is a story of what happens when you come face to face with evil incarnate.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey Konvitz
      </h2>
      
      <p class="authorDescription body article">Born in New York City, Jeffrey Konvitz is an entertainment lawyer, film producer, and novelist. A graduate of Cornell University and Columbia Law School, Konvitz has both written a&#160;<I>New York Times</I>&#160;bestseller (<I>The Sentinel</I>) and produced a film whose worldwide box office gross exceeded $100 million (<I>Spy Hard</I>).<BR /> &#160;<BR /> His first novel,<I>&#160;The Sentinel</I>&#160;(1974), was second on the&#160;<I>New York Times</I>&#160;Mass-Market Best Seller list and is considered to be a horror classic. After writing and producing the film adaptation of&#160;<I>The Sentinel</I>&#160;for Universal Pictures in 1977, Konvitz published two more bestselling novels:&#160;<I>The Guardian&#160;</I>(1979), the sequel to&#160;<I>The Sentinel</I>; and&#160;<I>Monster&#160;</I>(1982).<BR /> &#160;<BR /> Konvitz has served as executive producer and financing counsel for three major motion pictures:&#160;<I>O Jerusalem</I>,&#160;<I>I Could Never Be Your Woman</I>, and&#160;<I>The Flock.</I>&#160;He is currently working on a historical novel,&#160;<I>The Circus of Satan,</I>&#160;about the late-nineteenth-century destruction of the national Irish Mob and the subsequent rise of Italians and Jews in nationwide politics and crime in the early twentieth century.<BR /> &#160;<BR /> Konvitz is also preparing the third book in the Sentinel Trilogy, which continues the saga from where&#160;<I>The Guardian</I>&#160;left off.<BR /> &#160;<BR /> He currently resides in Los Angeles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2cdb70e7